<template>
  <div id="labels-page">
    <div class="flex flex-wrap items-center justify-between mb-4">
      <h3 class="mb-base mr-3">Étiquettes Produits</h3>
      <div class="flex items-center">
        <vs-button
          class="mb-base mr-3"
          icon-pack="feather"
          icon="icon icon-file"
          @click="printLabels"
          >Imprimer</vs-button
        >
      </div>
    </div>

    <div id="labels-container">
      <div
        v-for="(product, index) in products"
        :key="index"
        class="label"
      >
        <div class="label-content">
          <!-- Barcode -->
          <div class="barcode-section">
            <img
              :src="`https://barcodeapi.org/api/128/${encodeURIComponent(product.ref)}?dpi=203&height=50&text=none`"
              :alt="`Barcode ${product.ref}`"
              class="barcode-image"
            />
          </div>
          
          <!-- Product Info -->
          <div class="label-info">
            <div class="label-row">
              <span class="label-field">REF:</span>
              <span class="label-value">{{ product.ref }}</span>
            </div>
            <div class="label-row">
              <span class="label-field">Article:</span>
              <span class="label-value product-name">{{ product.name.length > 20 ? product.name.substring(0, 20) + '...' : product.name }}</span>
            </div>
            <div class="label-row">
              <span class="label-field">Prix:</span>
              <span class="label-value">{{ product.sale_price }} TND</span>
            </div>
            <div class="label-row">
              <span class="label-field">Dépôt:</span>
              <span class="label-value">{{ product.createdAt | datemongoose(true) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  methods: {
    printLabels() {
      // Build the HTML for each label
      const labelsHtml = this.products.map(product => {
        const dateStr = this.$options.filters.datemongoose
          ? this.$options.filters.datemongoose(product.createdAt, true)
          : product.createdAt;

        return `
          <div class="label">
            <div class="barcode-section">
              <img
                src="https://barcodeapi.org/api/128/${encodeURIComponent(product.ref)}?dpi=203&height=50&text=none"
                alt="Barcode ${product.ref}"
                class="barcode-image"
              />
            </div>
            <div class="label-info">
              <div class="label-row">
                <span class="label-field">REF:</span>
                <span class="label-value">${product.ref}</span>
              </div>
              <div class="label-row">
                <span class="label-field">Article:</span>
                <span class="label-value product-name">${product.name.length > 20 ? product.name.substring(0, 20) + '...' : product.name}</span>
              </div>
              <div class="label-row">
                <span class="label-field">Prix:</span>
                <span class="label-value">${product.sale_price} TND</span>
              </div>
              <div class="label-row">
                <span class="label-field">Dépôt:</span>
                <span class="label-value">${dateStr}</span>
              </div>
            </div>
          </div>
        `;
      }).join('');

      // Open a new window with ONLY label content — zero CSS conflicts
      const printWindow = window.open('', '_blank', 'width=400,height=400');
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Étiquettes</title>
          <style>
            @page {
              size: 50mm 30mm;
              margin: 0;
            }

            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            body {
              font-family: Arial, Helvetica, sans-serif;
            }

            .label {
              width: 50mm;
              height: 30mm;
              padding: 2mm;
              overflow: hidden;
              page-break-after: always;
            }

            .barcode-section {
              text-align: center;
              margin-bottom: 1mm;
            }

            .barcode-image {
              width: 100%;
              height: auto;
              max-height: 12mm;
            }

            .label-info {
              display: flex;
              flex-direction: column;
              gap: 0.5mm;
            }

            .label-row {
              display: flex;
              align-items: baseline;
              line-height: 1.1;
            }

            .label-field {
              font-weight: bold;
              margin-right: 1mm;
              font-size: 7pt;
              min-width: 14mm;
            }

            .label-value {
              flex: 1;
              font-size: 7pt;
            }

            .product-name {
              font-weight: 600;
              font-size: 8pt;
            }
          </style>
        </head>
        <body>
          ${labelsHtml}
        </body>
        </html>
      `);
      printWindow.document.close();

      // Wait for barcode images to load, then print
      printWindow.onload = () => {
        printWindow.print();
        printWindow.onafterprint = () => {
          printWindow.close();
        };
      };
    },
  },
};
</script>

<style lang="scss">
#labels-page {
  padding: 1rem;
}

#labels-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 1rem;
}

.label {
  width: 50mm;
  min-height: 30mm;
  border: 1px dashed #ccc;
  padding: 2mm;
  box-sizing: border-box;
}

.label-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.barcode-section {
  text-align: center;
  margin-bottom: 2mm;
}

.barcode-image {
  width: 100%;
  height: auto;
  max-height: 18mm;
}

.label-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1mm;
  font-size: 9pt;
}

.label-row {
  display: flex;
  align-items: baseline;
  line-height: 1.2;
}

.label-field {
  font-weight: bold;
  margin-right: 2mm;
  font-size: 8pt;
  min-width: 20mm;
}

.label-value {
  flex: 1;
  font-size: 9pt;
}

.product-name {
  font-weight: 600;
  font-size: 10pt;
}
</style>